import React, { useCallback } from 'react';
import { pick } from 'ramda';
import { dispatcher } from 'dispatcher';
import { languageService } from '@theme/js/services/language.service';
import { useAppSelector, usePageSelector, useUserSelector } from '@core/js/store/hooks';
import { BackboneReplacer } from '@theme/js/backbone/components/BackboneReplacer';
import { Link } from '@theme/js/components/common/Link';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';

import { Logo } from '../Logo';
import { MyAccount } from '../MyAccount';
import * as hooks from '@core/js/components/main/DefaultHeader/hooks';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    /* Lugano changes */
    const { lang, isLoggedIn } = useUserSelector(pick(['lang', 'isLoggedIn']));
    const language = languageService.getTwoLetterLanguage(lang);
    const { registrationURL, dynamicTags } = useAppSelector(pick(['registrationURL', 'dynamicTags']));
    /* Lugano changes */

    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { overrideMenu, menuWcId } = usePageSelector(pick(['overrideMenu', 'menuWcId']));
    const hideSideMenuIcon = overrideMenu && !menuWcId;
    const openSideMenu = useCallback(() => dispatcher.dispatch('menu:action:open'), []);

    /* Lugano changes */
    const openSearch = useCallback((event) => {
        event.preventDefault();
        dispatcher.dispatch('game:open:globalSearch');
    }, []);
    const regDTagName = `DTAG_LINK_REGISTRATION_${language.toUpperCase()}`;
    const regLink = dynamicTags[regDTagName] || registrationURL || '/';
    /* Lugano changes */

    /* Lugano changes */
    return (
        <div className={style.header}>
            {!hideSideMenuIcon && (
                <div className={style.sideMenu}>
                    <span onClick={openSideMenu}
                          className={`${style.sideMenuIcon} icon-ico-s4w-menu`}
                    />
                </div>
            )}
            <Logo />
            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            {/* Deposit section */}
                            <div className={style.deposit}>
                                <BackboneReplacer
                                        dynamicName="HEADER_DEPOSIT_BUTTON"
                                        viewName="headerdepositbutton"
                                        isHideBackboneClass={true}
                                />
                            </div>

                            {/* Search icon section */}
                            <div className={style.search}>
                                <span className={`${style.searchIcon} icon-ico-s4w-search`} onClick={openSearch} />
                            </div>

                            {/* User section */}
                            <MyAccount/>
                        </>
                    ) : (
                        <>
                            <Link href={regLink} className={style.register}>
                                {translate('login.button.join_now')}
                            </Link>
                            <button className={style.login} onClick={onLoginButtonClick}>
                                {translate('login.button.loginHeader')}
                            </button>
                        </>
                    )
                }
            </div>
        </div>
    );
    /* Lugano changes */
};
